(function($) {
    $(() => {
        let youTubeActions = {};

        function onPlayerReady(event) {
            youTubeActions = {
                start: () => {
                    event.target.playVideo();
                },
                stop: () => {
                    event.target.stopVideo();
                }
            };
        }

        window.onYouTubeIframeAPIReady = function() {
            new window.YT.Player('video-player', {
                width: '888',
                height: '500',
                playerVars: {},
                events: {
                    onReady: onPlayerReady
                }
            });
        };

        /**
         * @param block {jQuery}
         * @return {{start: function, stop: function}}
         */
        function getMediaPlayer(block) {
            // YouTube player is loaded
            if (youTubeActions.start) {
                return youTubeActions;
            }

            /**
             * HTML Video is loaded
             * @var {HTMLMediaElement}
             */
            const element = block.find('.playable').get(0);
            return {
                start: async () => {
                    await element.play();
                    element.controls = true;
                },
                stop: async () => {
                    element.pause();
                    element.currentTime = 0;
                    element.controls = false;
                }
            };
        }

        $('.playable__player').click(function() {
            const playableContainer = $(this).closest('.playable__container');

            if (!playableContainer.hasClass('is-playing')) {
                playableContainer.addClass('is-playing');

                const videoPlayer = getMediaPlayer($(this));
                videoPlayer.start();
            }
        });

        $('.playable__button--close').click(function() {
            const playableContainer = $(this).closest('.playable__container');
            playableContainer.removeClass('is-playing');
            const videoPlayer = getMediaPlayer(playableContainer);
            videoPlayer.stop();
        });
    });
})(jQuery);
